import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '../use-api';

const api = `core-2/adherence-settings/queue-limits`;

interface IProps {
  guid: string;
  limit: number;
}

export const useUpdateQueueLimit = () => {
  const { updateData } = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (dataProps: IProps) => updateData(api, dataProps),
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetQueueLimits']);
    },
  });

  return {
    mutateAsync,
    isLoading,
  };
};
